import { inject, Injectable } from '@angular/core';
import { WeappsServices } from '../api/weapps';
import type { paths as ALTAIR_PATHS } from '../api/weapps/altair2'
import { NewUserStore } from 'data/store/new-user.store';

export type GroupsData = ALTAIR_PATHS["/groups/{productId}"]["get"]["responses"][200]["content"]['application/json'];

@Injectable({
  providedIn: 'root'
})
export class NewGroupService {
  private newUserStore = inject(NewUserStore);

  async findGroupsByProduct(productId: string): Promise<GroupsData> {
    const api = await WeappsServices.altair();
    const response = await api.GET("/groups/{productId}", {
      params: {
        path: { productId: productId }
      }
    });

    if (response.response.status !== 200 || !response.data) {
      throw new Error(`Failed to fetch group data: ${response.response.statusText}`);
    } else {
      //Create a list of unique user ids from all the groups
      const userIds = new Set<string>();
      response.data.forEach(group => {
        group.members?.forEach(member => {
          userIds.add(member.id);
        });
      });

      //Load user data for these ids
      this.newUserStore.loadUsers(Array.from(userIds));

      return response.data;
    }
  }

  async removeMemberOrLeaveGroup(groupId: string, memberId: string) {
    const api = await WeappsServices.altair();
    const response = await api.DELETE("/group/{groupId}/member/{memberId}", {
      params: {
        path: { groupId: groupId, memberId: memberId }
      }
    });

    if (response.response.status !== 200) {
      throw new Error(`Failed to remove member or leave group: ${response.response.statusText}`);
    }
  }

  async closeGroup(groupId: string) {
    const api = await WeappsServices.altair();
    const response = await api.DELETE("/group/{id}", {
      params: {
        path: { id: groupId }
      }
    });

    if (response.response.status !== 200) {
      throw new Error(`Failed to remove member or leave group: ${response.response.statusText}`);
    }
  }

  async createGroup(name: string, productId:string): Promise<{id:string,name:string}>{
    const api = await WeappsServices.altair();
    const response = await api.POST("/group", {
      body:{
        name: name,
        productId: productId
      }
    });

    if (response.response.status !== 200 || !response.data) {
      throw new Error(`Failed to remove member or leave group: ${response.response.statusText}`);
    }
    return response.data;
  }

  // async getGroupCheckoutLink(linkId:string):Promise<string>{
  //   const api = await getCanopusAPI({authenticated:true});
  //   const response = await api.groupCheckout({
  //     linkId: linkId
  //   });
  //   return response.url;
  // }

}